<template>
  <v-flex
    fill-height
    lg12
    md12
  >
    <v-card class="fill-height">
      <v-toolbar
        color="secondary"
        dense
      >
        <v-toolbar-title class="primarytext--text">Le auto</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items class="primarytext--text justify-center align-center">
          <span class="ml-2">
            <v-icon
              small
              color="red lighten-4"
            >fas fa-circle</v-icon> - Da aggiornare
          </span>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-title>
        <v-btn
          color="tree"
          class="primary--text"
          @click.stop="newTargaClick"
        >
          <v-icon
            small
            left
            color="primary"
          >fas fa-plus</v-icon>Crea
        </v-btn>
        <v-spacer />
        <v-switch
          v-model="switchA"
          label="Mostrare solo da aggiornare"
          hide-details
          color="tree"
          class="my-0"
        />
        <v-text-field
          v-model="search"
          solo
          box
          append-icon="search"
          label="Ricerca..."
          color="tree"
          hide-details
        />
      </v-card-title>

      <vue-good-table
        ref="vueGood"
        :columns="headers"
        :rows="autoList"
        :sort-options="sortOpt"
        :pagination-options="paginationOpt"
        @on-row-click="onRowClick"
        @on-cell-click="onCellClick"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span
            v-if="props.column.field == 'tarif_km_aci'"
            :class="Boolean(+props.row.flag_da_aggiornare) ? 'red lighten-5' : ''"
            class="body-2"
          >
            <v-edit-dialog
              transition="slide-y-reverse-transition"
              large
              lazy
              persistent
              cancel-text="Cancella"
              save-text="Modifica"
              @save="changeACI(props.row.targa, tarif_km_aci, props.row.tarif_km_aci)"
              @open="tarif_km_aci = props.row.tarif_km_aci"
            >
              <v-tooltip bottom>
                <template
                  slot="activator"
                  slot-scope="{ on }"
                >
                  <span v-on="on">
                    {{ props.row.tarif_km_aci || 0 }}
                    <v-icon
                      v-if="Boolean(+props.row.flag_da_aggiornare)"
                      :color="!Boolean(props.row.tarif_km_aci) ? 'red lighten-1' : 'amber lighten-1'"
                      right
                      dark
                      small
                    >fas fa-exclamation</v-icon>
                  </span>
                </template>
                <span>Clica per modificare</span>
              </v-tooltip>
              <v-text-field
                slot="input"
                v-model="tarif_km_aci"
                color="tree"
                label="Modifica"
                type="number"
              />
            </v-edit-dialog>
          </span>
          <span v-else-if="props.column.field == 'img_libretto64'">
            <v-btn
              flat
              icon
              color="tree"
              @click.stop="open_modal(props.row)"
            >
              <v-icon>fas fa-file-invoice</v-icon>
            </v-btn>
          </span>
          <span v-else-if="props.column.field == 'login_privato'">
            <v-layout
              align-center
              wrap
            >
              <template v-for="login in (props.formattedRow[props.column.field] || '').split(',')">
                <v-chip
                  v-if="login"
                  :key="login"
                  label
                  close
                  small
                  color="secondary"
                  @input="removeLoginPrivatoHandler(props.formattedRow.targa, login)"
                  @click.stop=""
                  outline
                >{{ login }}</v-chip>

              </template>
              <v-tooltip bottom>

                <template
                  slot="activator"
                  slot-scope="{ on }"
                >
                  <v-btn
                    v-if="props.row.id_tipo_auto == 5"
                    v-on="on"
                    style="margin-left: auto; order: 2;"
                    small
                    flat
                    icon
                    color="red"
                    @click.stop="addLoginPrivatoHandler(props.formattedRow.targa)"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>

                </template>
                <span>Associare nuovo login</span>
              </v-tooltip>
            </v-layout>
          </span>
          <span
            v-else
            class="body-2"
          >
            {{ (props.formattedRow[props.column.field]||'').toUpperCase() }}
          </span>
        </template>
      </vue-good-table>
    </v-card>
    <ImagePdfPreview
      :src="current_img_64"
      :name="current_img"
      :show="dialog"
      @on-click-close="close_modal"
    />
    <ModalNuovaTarga
      :dialog="modalNewTarga"
      @on-save="onSaveModalNuovaTarga"
      @on-close="onCloseModalNuovaTarga"
    />
    <ModalEditTarga
      ref="modalEdit"
      @on-update="updateAutoHandler"
    />
  </v-flex>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import ImagePdfPreview from "./ImagePdfPreview.vue";
import ModalNuovaTarga from "./ModalNuovaTarga.vue";
import ModalEditTarga from "./ModalEditTarga.vue";

export default {
  name: "AccVerificaAuto",
  components: { ImagePdfPreview, ModalNuovaTarga, ModalEditTarga, VueGoodTable },
  props: {},
  data: (vm) => ({
    search: "",
    switchA: false,
    current_img: "",
    current_img_64: "",
    targa: null,
    marca: null,
    tarif_km_aci: null,
    loader: false,
    paginationOpt: {
      enabled: true,
      mode: 'records',
      rowsPerPageLabel: 'Elementi per pagina',
      perPage: 5,
      position: 'top'
    },
    searchOpt: {
      enabled: true,
      externalQuery: vm.search
    },
    sortOpt: {
      enabled: true,
      initialSortBy: { field: 'intestatario', type: 'asc' }
    },
    headers: [
      {
        label: "Targa",
        field: "targa",
        width: '50px',
        filterable: true,
        filterOptions: {
          enabled: true,
          placeholder: "Targa",
          filterDropdownItems: [],
        }
      },
      {
        label: "Tipo auto",
        field: "autotipo",
        width: '150px',
        filterable: true,
        filterOptions: {
          enabled: true,
          placeholder: "Tipo auto",
          filterDropdownItems: ['AUTO PRIVATA', 'AUTO A NOLEGGIO'],
        }
      },
      {
        label: "Marca",
        field: "marca",
        width: '100px',
        filterable: true,
        filterOptions: {
          enabled: true,
          placeholder: "Marca",
          filterDropdownItems: [],
        }
      },
      {
        label: "Modello",
        field: "modello",
        filterable: true,
        filterOptions: {
          enabled: true,
          placeholder: "Modello",
          filterDropdownItems: [],
        }
      },
      {
        label: "Anno",
        field: "anno",
        width: '100px',
        filterable: true,
        filterOptions: {
          enabled: true,
          placeholder: "Anno",
          filterDropdownItems: [],
        }
      },
      {
        label: "Alimentazione",
        field: "alimentazione",
        width: '100px',
        filterable: true,
        filterOptions: {
          enabled: true,
          placeholder: "Alimentazione",
          filterDropdownItems: [],
        }
      },
      {
        label: "Intestatario",
        field: "intestatario",
        filterable: true,
        filterOptions: {
          enabled: true,
          placeholder: "Intestatario",
          filterDropdownItems: [],
        }
      },
      {
        label: "Logins privato",
        field: "login_privato",
        filterable: true,
        filterOptions: {
          enabled: true,
          placeholder: "Logins",
          filterDropdownItems: [],
        }
      },
      {
        label: "Tarif ACI",
        field: "tarif_km_aci",
        width: '100px',
        filterable: false,
        sortFn: vm.sortTariff,
      },
      {
        label: "Libretto",
        field: "img_libretto64",
        width: '50px',
        filterable: false,
      },
    ],
    dialog: false,
    modalNewTarga: false
  }),
  computed: {
    autoList () {
      return this.switchA ? this.$store.getters["gestione/autoNonAggiornate"] : this.$store.getters["gestione/auto"];
    },
    rowIconName () {
      return item => {

      }
    },
    rowIconColor () {
      return item => {

      }
    }
  },
  methods: {
    removeLoginPrivatoHandler (targa, login) {
      this.$store.dispatch("gestione/removeLoginPrivato", { targa, login })
    },
    async addLoginPrivatoHandler (targa) {
      const { value: login } = await this.$swal.fire({
        title: 'Inserisci login da associare',
        input: 'text',
        inputLabel: 'Login',
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return 'Login è obbligatoria!'
          }
        }
      })

      if (login) {
        this.$store.dispatch("gestione/addLoginPrivato", { targa, login })
      }
    },
    sortTariff (x, y, col, rowX, rowY) {
      return (+x < +y ? -1 : (+x > +y ? 1 : 0));
    },
    changeAutoItem (type, targa, value, oldValue) {
      if (value !== oldValue) {
        this.$swal({
          title: "Sei sicuro di voler cambiare " + type + "?",
          showCancelButton: true,
          confirmButtonText: "Modifica",
          cancelButtonText: "Cancella"
        }).then(result => {
          if (result.value) {
            this.$emit("change-auto-item", {
              tipo: type,
              targa: targa,
              valore: value
            });
          }
        });
      }
    },
    closeDialogChangeHandler () {
      this.citta = null;
      this.via = null;
      this.km = null;
    },
    open_modal (item) {
      this.$store.dispatch("gestione/getAutoLibterro", { idAuto: item.id }).then(res => {
        if (res.stato === 'success') {
          this.current_img = res.data.img_libretto;
          this.current_img_64 = res.data.img_libretto64;
          this.dialog = true;
        } else {
          this.$notify({
            group: res.stato,
            text: res.textError
          });
        }
      });
    },
    close_modal () {
      this.current_img = "";
      this.current_img_64 = "";
      this.dialog = false;
    },
    newTargaClick () {
      this.modalNewTarga = true;
    },
    onCloseModalNuovaTarga () {
      this.modalNewTarga = false;
      //      this.newTargaType = "";
    },
    onSaveModalNuovaTarga (dataForm) {
      this.$store.dispatch("gestione/newTarga", dataForm).then(r => {
        if (r) {
          this.modalNewTarga = false;
        }
      });
    },
    changeACI (targa, value, oldValue) {
      if (value !== oldValue) {
        this.$swal({
          title: "Sei sicuro di volere cambiare ACI?",
          showCancelButton: true,
          confirmButtonText: "Modifica",
          cancelButtonText: "Cancella"
        }).then(result => {
          if (result.value) {
            this.$store.dispatch("gestione/setCoefficiente", {
              targa: targa,
              coefficiente: value
            });
          }
        });
      }
    },
    updateAutoHandler (item) {
      this.$swal({
        title: "Sei sicuro di volere cambiare auto dati?",
        showCancelButton: true,
        confirmButtonText: "Modifica",
        cancelButtonText: "Cancella"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("gestione/updateAuto", item)
            .then(r => { if (r) this.$refs.modalEdit.close() })
        }
      });
    },
    onRowClick (tableRow) {
      this.$refs.modalEdit.open(tableRow.row)
    },
    onCellClick (tableCell) {
      if (['tarif_km_aci', 'img_libretto64'].includes(tableCell.column.field)) {
        tableCell.event.stopPropagation();
        return false;
      }
    }
  }
};
</script>

<style lang="scss">
.v-text-field--box.v-text-field--single-line input {
  margin-top: 0 !important;
}
.v-small-dialog__actions {
  button.v-btn {
    color: #01579b !important;
    caret-color: #01579b !important;
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabVerificaAuto.vue